<template>
  <div class="table-search-container">
    <a-select
      style="width: 200px"
      class="select-container"
      placeholder="请选择职称"
      @change="(value) => $emit('onChangeRank', value)"
    >
      <a-select-option v-for="item in rankData" :key="item.id" :value="item.id">
        {{ item.name }}
      </a-select-option>
    </a-select>

    <a-tree-select
      style="width: 200px"
      class="select-container"
      :tree-data="sectionData"
      placeholder="请选择科室"
      @change="(value) => $emit('onChangeSection', value)"
    />
    <a-input-search
      placeholder="请输入姓名、手机号、医院..."
      style="width: 250px; margin-right: 20px"
      allow-clear
      @search="(value) => $emit('onSearch', value)"
    />
    <a-select
      v-model="defaultId"
      style="width: 200px"
      placeholder="请选择合作企业"
      @change="(value) => $emit('onChangecompany', value)"
    >
      <a-select-option
        v-for="item in companyData"
        :key="item.id"
        :value="item.id"
      >
        {{ item.companyInfo.qichacha_name }}
      </a-select-option>
    </a-select>
    <a-button
      type="primary"
      shape="round"
      icon="plus"
      style="margin-left: 0px"
      @click="$emit('editAndAdd')"
    >
      新增医生
    </a-button>
    <!--    <a-button
      shape="round"
      icon="plus"
      style="margin-right:20px"
      @click="upLoad"
    >
      下载模板
    </a-button> -->
    <!--    <a-upload
      name="upload"
      style="margin-right:20px"
      :with-credentials="false"
      :data="{fileType:'file',}"
      :action="`${uploadUrl}system/upload`"
      @change="(event)=>$emit('importDoctors',event)"
    >
      <a-tooltip
        placement="bottom"
      >
        <template
          slot="title"
        >
          <span>提示：按照模板格式导入</span>
        </template>
        <a-button shape="round">
          <a-icon type="upload" /> 导入医生
        </a-button>
      </a-tooltip>
    </a-upload> -->
    <a-button
      type="primary"
      shape="round"
      icon="upload"
      style="margin-left: 20px"
      @click="$emit('importShow')"
    >
      导入医生
    </a-button>
  </div>
</template>
<script>
export default {
  data() {
    return {
      companyData: [],
      rankData: [{ id: "0", name: "所有" }],
      defaultId: null,
      sectionData: [{ value: "0", key: 0, title: "所有" }],
    };
  },
  mounted() {
    // 获取科室
    this.getSectionData();
    // 获取职称数据
    this.getRankData();
    this.getCompanyList();
  },
  methods: {
    // 递归处理
    dealData(data) {
      data.forEach((item) => {
        item.title = item.name;
        item.key = item.id;
        item.value = String(item.id);
        item.children = item.child_list;
        if (item.child_list && item.child_list.length > 0) {
          this.dealData(item.child_list);
        }
      });
      return data;
    },
    // 获取合作企业
    async getCompanyList() {
      let result = await this.$http.post("/Company/getCooperationCompanyList");
      if (result.data.status === 1) {
        this.companyData = result.data.data.data_list;
        this.defaultId = result.data.data.data_list[0].id;
      }
    },
    // 获取职称数据
    async getRankData() {
      let result = await this.$http.post("/system/getProfessionalList");
      if (result.data.status === 1) {
        let data = result.data.data.data_list;
        this.rankData = [...this.rankData, ...data];
      }
    },
    // 获取科室数据
    async getSectionData() {
      let result = await this.$http.post("/doctor/departmentList");
      if (result.data.status === 1) {
        let data = result.data.data.data_list;
        this.sectionData = [
          ...this.sectionData,
          ...this.dealData(JSON.parse(JSON.stringify(data))),
        ];
      }
    },
    // 下载模板
    upLoad() {
      console.log(this.doctorUpload);
      window.open(`${this.doctorUpload}/storage/default/doctor_templete.xlsx`);
    },
  },
};
</script>
<style lang="scss">
.table-search-container {
  height: 70px;
  line-height: 70px;
  .ant-input {
    border-radius: 15px;
    height: 30px;
  }
  .ant-select-selection {
    border-radius: 15px;
    margin-right: 20px;
  }
  .ant-btn-round {
    font-size: 12px;
    height: 30px;
    padding: 0 17px;
    border-radius: 15px;
  }
}
.ant-tooltip-inner {
  font-size: 12px;
}
</style>
